'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.connect = connect;

var _observer = require('./observer');

var _inject = require('./inject');

function connect(arg1, arg2) {
    if (typeof arg1 === 'string') {
        throw new Error('Store names should be provided as array');
    }
    if (Array.isArray(arg1)) {
        if (!arg2) {
            // invoked as decorator
            return function (componentClass) {
                return connect(arg1, componentClass);
            };
        } else {
            return _inject.inject.apply(null, arg1)(connect(arg2));
        }
    }
    return (0, _observer.observer)(arg1);
}


// WEBPACK FOOTER //
// ../node_modules/mobx-preact/lib/connect.js